module.exports = __webpack_public_path__ + "img/hero-text-1.75ca6c6e.svg";